import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { Body1, Caption1 } from '@fluentui/react-components';

import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const CompanyPage = ({ Name, IndustryType, Location }) => {
  const caption = _.chain([IndustryType, Location]).compact().value().join(' · ');

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Company') }}>
      <div>
        <Body1 block>{Name}</Body1>
        <Caption1 block>{caption}</Caption1>
      </div>
    </PropertyRow>
  );
};

CompanyPage.propTypes = {
  Name: PropTypes.string.isRequired,
  IndustryType: PropTypes.string.isRequired,
  Location: PropTypes.string.isRequired,
};

